<template>
    <div style="background: #fff" v-loading="pdfLoading">
        <div class="box" v-if="showResult&&hasFinished">
            <h1 class="serviceTestTitle">Radiography Exam</h1>
            <!--
            <span>Of the parts of this exam that can be automatically graded you have recieved </span>
            <span>{{getScore}}</span>/{{totalNum}} ({{correctPercent}})-->
            <span>Thank you for completing this knowledge assessment!</span><br/>
            <span>Please allow up to three business days while we review your application.</span>
            <br>
            <el-button class="yellowBtn" style="margin-top: 10px;" @click="goPre">Back</el-button>
        </div>
        <el-form v-show="!pdfLoading" :model="form" ref="form" :rules="rules" v-if="!showResult&&hasFinished">
            <div class="smallBox" style="min-height: 180px">
                <div class="beakLine" style="height: 20px;line-height: 20px">
                    <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!correctSub0"></el-image>
                    <span>#1</span>
                </div>

                <u class="viewPic" @click="openPic(1)">Radiograph #1</u>
                <el-form-item prop="sub0" ref="sub0">
                    <div class="titleInner"> <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&(!form.sub0.a||form.sub0.b||form.sub0.c||form.sub0.d||form.sub0.e)"></el-image>
                        What procedure(s) has been completed on teeth 18,19,and 20?</div>
                    <div class="select">
                        <el-checkbox v-model="form.sub0.a" :disabled="isAdmin">Bridge</el-checkbox><br>
                        <el-checkbox v-model="form.sub0.b" :disabled="isAdmin">Build up</el-checkbox><br>
                        <el-checkbox v-model="form.sub0.c" :disabled="isAdmin">Crown</el-checkbox><br>
                        <el-checkbox v-model="form.sub0.d" :disabled="isAdmin">Implant</el-checkbox><br>
                        <el-checkbox v-model="form.sub0.e" :disabled="isAdmin">Root canal</el-checkbox>
                    </div>
                    <div class="key" v-if="isAdmin&&(!form.sub0.a||form.sub0.b||form.sub0.c||form.sub0.d||form.sub0.e)">
                        Bridge
                    </div>
                </el-form-item>
            </div>

            <div class="smallBox" style="min-height: 180px">
                <div class="beakLine" style="height: 20px;line-height: 20px">
                    <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!correctSub1"></el-image>
                    <span >#2</span>
                </div>
                <u class="viewPic" @click="openPic(2)">Radiograph #2</u>
                <el-form-item prop="sub1">
                    <div class="titleInner"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub1!=1"></el-image>
                        What type of image is this?</div>
                    <el-radio-group ref="sub1" v-model="form.sub1" placeholder="" class="radioGroup" :disabled="isAdmin">
                        <el-radio :label="0">Bitewing</el-radio><br>
                        <el-radio :label="1">Panoramic</el-radio><br>
                        <el-radio :label="2">Intra-oral</el-radio><br>
                        <el-radio :label="3">Periapical</el-radio>
                    </el-radio-group>
                    <div class="key" v-if="isAdmin&&form.sub1!=1">
                        Panoramic
                    </div>
                </el-form-item>

                <el-form-item class="mt90" prop="sub2">
                    <div class="titleInner"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub2!=1"></el-image>
                        Are the patients wisdom teeth still present?</div>
                    <div class="titleInner">
                        <el-select ref="sub2" v-model="form.sub2" placeholder="" class="select" :disabled="isAdmin">
                            <el-option label="Yes" :value="1"></el-option>
                            <el-option label="No" :value="0"></el-option>
                        </el-select>
                    </div>
                    <div class="key" v-if="isAdmin&&form.sub2!=1">
                        Yes
                    </div>
                </el-form-item>
            </div>

            <div class="smallBox" style="min-height: 240px">
                <div class="beakLine" style="height: 20px;line-height: 20px">
                    <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!correctSub2"></el-image>
                    <span >#3</span>
                </div>
                <u class="viewPic" @click="openPic(3)">Radiograph #3</u>
                <el-form-item prop="sub3">
                    <div class="titleInner"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub3!=0"></el-image>What type of image is this?</div>
                    <el-radio-group ref="sub3" v-model="form.sub3" placeholder="" class="radioGroup" :disabled="isAdmin">
                        <el-radio :label="0" :disabled="isAdmin">Bitewing</el-radio><br>
                        <el-radio :label="1" :disabled="isAdmin">Panoramic</el-radio><br>
                        <el-radio :label="2" :disabled="isAdmin">Intra-oral</el-radio><br>
                        <el-radio :label="3" :disabled="isAdmin">Periapical</el-radio>
                    </el-radio-group>
                    <div class="key" v-if="isAdmin&&form.sub3!=0">
                        Bitewing
                    </div>
                </el-form-item>

                <el-form-item prop="sub4" class="mt90">
                    <div class="titleInner"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub4!=1"></el-image>
                        Is this an x-ray for full grown adult or child?</div>
                    <el-radio-group ref="sub4" v-model="form.sub4" placeholder="" class="radioGroup" :disabled="isAdmin">
                        <el-radio :label="0">Adult</el-radio><br>
                        <el-radio :label="1">Child</el-radio>
                    </el-radio-group>
                    <div class="key" v-if="isAdmin&&form.sub4!=1">
                        Child
                    </div>
                </el-form-item>

            </div>

            <div class="smallBox" style="min-height: 340px">
                <div class="beakLine" style="height: 20px;line-height: 20px">
                    <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!correctSub3"></el-image>
                    <span >#4</span>
                </div>
                <u class="viewPic" @click="openPic(4)">Radiograph #4</u>
                <el-form-item prop="sub5" ref="sub5">
                    <div class="titleInner"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!(form.sub5.b&&form.sub5.e&&!form.sub5.a&&!form.sub5.c&&!form.sub5.d)"></el-image>
                        What types of procedures are being performed in these x-rays?</div>
                    <div class="select">
                        <el-checkbox :disabled="isAdmin" v-model="form.sub5.a">Bridge</el-checkbox><br>
                        <el-checkbox :disabled="isAdmin" v-model="form.sub5.b">Build up</el-checkbox><br>
                        <el-checkbox :disabled="isAdmin" v-model="form.sub5.c">Crown</el-checkbox><br>
                        <el-checkbox :disabled="isAdmin" v-model="form.sub5.d">Implant</el-checkbox><br>
                        <el-checkbox :disabled="isAdmin" v-model="form.sub5.e">Root canal</el-checkbox>
                    </div>
                    <div class="key" v-if="isAdmin&&!(form.sub5.b&&form.sub5.e&&!form.sub5.a&&!form.sub5.c&&!form.sub5.d)">
                        Build up
                    </div>
                    <div class="key mt30" v-if="isAdmin&&!(form.sub5.b&&form.sub5.e&&!form.sub5.a&&!form.sub5.c&&!form.sub5.d)">
                        Root canal
                    </div>
                </el-form-item>

                <el-form-item prop="sub6" style="margin-top: 120px">
                    <div class="titleInner"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub6!=1"></el-image>
                        Would you send all these x-rays with the claim to insurance?</div>
                    <div class="titleInner">
                        <el-select ref="sub6" v-model="form.sub6" placeholder="" class="select" :disabled="isAdmin">
                            <el-option label="Yes" :value="1"></el-option>
                            <el-option label="No" :value="0"></el-option>
                        </el-select>
                    </div>
                    <div class="key" v-if="isAdmin&&form.sub6!=1">
                        Yes
                    </div>
                </el-form-item>

                <el-form-item prop="sub7" class="mt10">
                    <div class="titleInner">Why or Why not?</div>
                    <el-input type="textarea" class="textarea" v-model="form.sub7" :readonly="isAdmin"></el-input>
                </el-form-item>
            </div>

            <div class="smallBox" style="min-height: 200px">
                <div class="beakLine" style="height: 20px;line-height: 20px">
                    <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!correctSub4"></el-image>
                    <span >#5</span>
                </div>
                <u class="viewPic" @click="openPic(5)">Radiograph #5</u>
                <el-form-item prop="sub8">
                    <div class="titleInner"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub8!=1"></el-image>
                        Out of the two x-rays showing,which one would you send to insurance as a pre-operative x-ray for a root canal?</div>
                    <el-radio-group ref="sub8" v-model="form.sub8" placeholder="" class="radioGroup" :disabled="isAdmin">
                        <el-radio :label="0">Left</el-radio><br>
                        <el-radio :label="1">Right</el-radio><br>
                    </el-radio-group>
                    <div class="key" v-if="isAdmin&&form.sub8!=1">
                        Right
                    </div>
                </el-form-item>

                <el-form-item prop="sub9" class="mt10">
                    <div class="titleInner">Why?</div>
                    <el-input type="textarea" class="textarea" v-model="form.sub9" :readonly="isAdmin"></el-input>
                </el-form-item>
            </div>

            <div class="smallBox" style="min-height: 200px">
                <div class="beakLine" style="height: 20px;line-height: 20px">
                    <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!correctSub5"></el-image>
                    <span >#6</span>
                </div>
                <u class="viewPic" @click="openPic(6)">Radiograph #6</u>
                <el-form-item prop="sub10">
                    <div class="titleInner"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub10!=0"></el-image>
                        Are the x-rays showing the appropriate x-rays to send  to insurance for a root canal procedure?</div>
                    <div class="titleInner">
                        <el-select ref="sub10" v-model="form.sub10" placeholder="" class="select" :disabled="isAdmin">
                            <el-option label="Yes" :value="1"></el-option>
                            <el-option label="No" :value="0"></el-option>
                        </el-select>
                    </div>
                    <div class="key" v-if="isAdmin&&form.sub10!=0">
                        No
                    </div>
                </el-form-item>

                <el-form-item prop="sub11" class="mt10">
                    <div class="titleInner">Why or why not?</div>
                    <el-input ref="sub11" v-model="form.sub11" type="textarea" class="textarea" :readonly="isAdmin"></el-input>
                </el-form-item>
            </div>

            <div class="smallBox" style="min-height: 180px">
                <div class="beakLine" style="height: 20px;line-height: 20px">
                    <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!correctSub6"></el-image>
                    <span >#7</span>
                </div>
                <u class="viewPic" @click="openPic(7)">Radiograph #7</u>
                <el-form-item prop="sub12" ref="sub12">
                    <div class="titleInner">
                        <el-image :src="wrong" style="width: 20px"
                                  v-if="isAdmin&&!(form.sub12.b&&form.sub12.e&&!form.sub12.a&&!form.sub12.c&&!form.sub12.d)"></el-image>
                        If these x-rays are of the upper right arch, what procedure(s) has been done on tooth #3?</div>
                    <div class="select">
                        <el-checkbox v-model="form.sub12.a" :disabled="isAdmin">Bridge</el-checkbox><br>
                        <el-checkbox v-model="form.sub12.b" :disabled="isAdmin">Build up</el-checkbox><br>
                        <el-checkbox v-model="form.sub12.c" :disabled="isAdmin">Crown</el-checkbox><br>
                        <el-checkbox v-model="form.sub12.d" :disabled="isAdmin">Implant</el-checkbox><br>
                        <el-checkbox v-model="form.sub12.e" :disabled="isAdmin">Root canal</el-checkbox>
                    </div>
                    <div class="key" v-if="isAdmin&&!(form.sub12.b&&form.sub12.e&&!form.sub12.a&&!form.sub12.c&&!form.sub12.d)">
                        Build up
                    </div>
                    <div class="key mt30" v-if="isAdmin&&!(form.sub12.b&&form.sub12.e&&!form.sub12.a&&!form.sub12.c&&!form.sub12.d)">
                        Root canal
                    </div>
                </el-form-item>
            </div>

            <div class="smallBox" style="min-height: 500px">
                <div class="beakLine" style="height: 20px;line-height: 20px">
                    <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!correctSub7"></el-image>
                    <span >#8</span>
                </div>
                <u class="viewPic" @click="openPic(8)">Radiograph #8</u>
                <el-form-item prop="sub13" ref="sub13">
                    <div class="titleInner">
                        <el-image :src="wrong" style="width: 20px"
                                  v-if="isAdmin&&!(form.sub13.c&&form.sub13.d&&form.sub13.e&&form.sub13.f&&!form.sub13.a&&!form.sub13.b&&!form.sub13.g&&!form.sub13.h)"></el-image>
                        What teeth numbers are visible in this x-ray?</div>
                    <div class="select">
                        <el-checkbox v-model="form.sub13.a" :disabled="isAdmin">5</el-checkbox><br>
                        <el-checkbox v-model="form.sub13.b" :disabled="isAdmin">6</el-checkbox><br>
                        <el-checkbox v-model="form.sub13.c" :disabled="isAdmin">7</el-checkbox><br>
                        <el-checkbox v-model="form.sub13.d" :disabled="isAdmin">8</el-checkbox><br>
                        <el-checkbox v-model="form.sub13.e" :disabled="isAdmin">9</el-checkbox><br>
                        <el-checkbox v-model="form.sub13.f" :disabled="isAdmin">10</el-checkbox><br>
                        <el-checkbox v-model="form.sub13.g" :disabled="isAdmin">11</el-checkbox><br>
                        <el-checkbox v-model="form.sub13.h" :disabled="isAdmin">12</el-checkbox>
                    </div>
                    <div class="key" v-if="isAdmin&&!(form.sub13.c&&form.sub13.d&&form.sub13.e&&form.sub13.f&&!form.sub13.a&&!form.sub13.b&&!form.sub13.g&&!form.sub13.h)">
                        7
                    </div>
                    <div class="key mt30" v-if="isAdmin&&!(form.sub13.c&&form.sub13.d&&form.sub13.e&&form.sub13.f&&!form.sub13.a&&!form.sub13.b&&!form.sub13.g&&!form.sub13.h)">
                        8
                    </div>
                    <div class="key mt60" v-if="isAdmin&&!(form.sub13.c&&form.sub13.d&&form.sub13.e&&form.sub13.f&&!form.sub13.a&&!form.sub13.b&&!form.sub13.g&&!form.sub13.h)">
                        9
                    </div>
                    <div class="key mt90" v-if="isAdmin&&!(form.sub13.c&&form.sub13.d&&form.sub13.e&&form.sub13.f&&!form.sub13.a&&!form.sub13.b&&!form.sub13.g&&!form.sub13.h)">
                        10
                    </div>
                </el-form-item>

                <el-form-item prop="sub14" style="margin-top: 200px" ref="sub14">
                    <div class="titleInner"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&(!form.sub14.d||form.sub14.a||form.sub14.b||form.sub14.c||form.sub14.e||form.sub14.f||form.sub14.g||form.sub14.h)"></el-image>
                        which tooth is fractured?</div>
                    <div class="select">
                        <el-checkbox v-model="form.sub14.a" :disabled="isAdmin">5</el-checkbox><br>
                        <el-checkbox v-model="form.sub14.b" :disabled="isAdmin">6</el-checkbox><br>
                        <el-checkbox v-model="form.sub14.c" :disabled="isAdmin">7</el-checkbox><br>
                        <el-checkbox v-model="form.sub14.d" :disabled="isAdmin">8</el-checkbox><br>
                        <el-checkbox v-model="form.sub14.e" :disabled="isAdmin">9</el-checkbox><br>
                        <el-checkbox v-model="form.sub14.f" :disabled="isAdmin">10</el-checkbox><br>
                        <el-checkbox v-model="form.sub14.g" :disabled="isAdmin">11</el-checkbox><br>
                        <el-checkbox v-model="form.sub14.h" :disabled="isAdmin">12</el-checkbox>
                    </div>
                    <div class="key" v-if="isAdmin&&(!form.sub14.d||form.sub14.a||form.sub14.b||form.sub14.c||form.sub14.e||form.sub14.f||form.sub14.g||form.sub14.h)">
                        8
                    </div>
                </el-form-item>
            </div>

            <div class="smallBox" style="min-height: 220px">
                <div class="beakLine" style="height: 20px;line-height: 20px">
                    <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!correctSub8"></el-image>
                    <span >#9</span>
                </div>
                <u class="viewPic" @click="openPic(9)">Radiograph #9</u>
                <el-form-item prop="sub15">
                    <div class="titleInner"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub15!=2"></el-image>
                        What type of images is this?</div>
                    <el-radio-group ref="sub15" v-model="form.sub15" placeholder="" class="radioGroup" :disabled="isAdmin">
                        <el-radio :label="0">Bitewing</el-radio><br>
                        <el-radio :label="1">Panoramic</el-radio><br>
                        <el-radio :label="2">Intra-oral</el-radio><br>
                        <el-radio :label="3">Periapcial</el-radio>
                    </el-radio-group>
                    <div class="key" v-if="isAdmin&&form.sub15!=2">
                        Intra-oral
                    </div>
                </el-form-item>

                <el-form-item prop="sub16" class="mt90">
                    <div class="titleInner">Why would you send this to insurance?</div>
                    <el-input ref="sub16" type="textarea" class="textarea" v-model="form.sub16" :readonly="isAdmin"></el-input>
                </el-form-item>
            </div>

            <div class="smallBox" style="min-height: 220px">
                <div class="beakLine" style="height: 20px;line-height: 20px">
                    <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!correctSub9"></el-image>
                    <span >#10</span>
                </div>
                <u class="viewPic" @click="openPic(10)">Radiograph #10</u>
                <el-form-item prop="sub17">
                    <div class="titleInner"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub17!=0"></el-image>
                        What kind of appliance is shown in this x-ray?</div>
                    <el-radio-group ref="sub17" v-model="form.sub17" placeholder="" class="radioGroup" :disabled="isAdmin">
                        <el-radio :label="0">Permanent retainer</el-radio><br>
                        <el-radio :label="1">Braces</el-radio><br>
                        <el-radio :label="2">MonoBlock</el-radio><br>
                        <el-radio :label="3">Splint</el-radio>
                    </el-radio-group>
                    <div class="key fs12" v-if="isAdmin&&form.sub17!=0">
                        Permanent retainer
                    </div>
                </el-form-item>

                <el-form-item prop="sub18" class="mt90">
                    <div class="titleInner"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub18!=1"></el-image>
                        Is this of the upper or lower front teeth?</div>
                    <el-radio-group ref="sub18" v-model="form.sub18" placeholder="" class="radioGroup" :disabled="isAdmin">
                        <el-radio :label="0">Upper</el-radio><br>
                        <el-radio :label="1">Lower</el-radio>
                    </el-radio-group>
                    <div class="key" v-if="isAdmin&&form.sub18!=1">
                        Lower
                    </div>
                </el-form-item>
            </div>

            <div class="smallBox" style="min-height: 180px">
                <div class="beakLine" style="height: 20px;line-height: 20px">
                    <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!correctSub10"></el-image>
                    <span >#11</span>
                </div>
                <u class="viewPic" @click="openPic(11)">Radiograph #11</u>
                <el-form-item prop="sub19">
                    <div class="titleInner"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub19!=3"></el-image>
                        What kind of restoration is visible?</div>
                    <el-radio-group ref="sub19" v-model="form.sub19" placeholder="" class="radioGroup" :disabled="isAdmin">
                        <el-radio :label="0">Crown</el-radio><br>
                        <el-radio :label="1">Composite filling</el-radio><br>
                        <el-radio :label="2">Build up</el-radio><br>
                        <el-radio :label="3">Amalgam filling</el-radio><br>
                        <el-radio :label="4">Root canal</el-radio>
                    </el-radio-group>
                    <div class="key" v-if="isAdmin&&form.sub19!=3">
                        Amalgam filling
                    </div>
                </el-form-item>
            </div>

            <div class="smallBox" style="min-height: 570px">
                <div class="beakLine" style="height: 20px;line-height: 20px">
                    <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!correctSub11"></el-image>
                    <span >#12</span>
                </div>
                <div>Answer the following questions based on the x-ray and dates taken.</div>
                <u class="viewPic" @click="openPic(12)">Radiograph #12</u>
                <el-form-item prop="sub20" ref="sub20">
                    <div class="titleInner">
                        <el-image :src="wrong" style="width: 20px"
                                  v-if="isAdmin&&!(form.sub20.c&&form.sub20.e&&form.sub20.f&&!form.sub20.a&&!form.sub20.b&&!form.sub20.d)"></el-image>
                        What procedures show being completed on tooth 7 on 7/25/11?</div>
                    <div class="select">
                        <el-checkbox v-model="form.sub20.a" :disabled="isAdmin">Bridge</el-checkbox><br>
                        <el-checkbox v-model="form.sub20.b" :disabled="isAdmin">Build up</el-checkbox><br>
                        <el-checkbox v-model="form.sub20.c" :disabled="isAdmin">Crown</el-checkbox><br>
                        <el-checkbox v-model="form.sub20.d" :disabled="isAdmin">Implant</el-checkbox><br>
                        <el-checkbox v-model="form.sub20.e" :disabled="isAdmin">Post and Core</el-checkbox><br>
                        <el-checkbox v-model="form.sub20.f" :disabled="isAdmin">Root canal</el-checkbox>
                    </div>
                    <div class="key" v-if="isAdmin&&!(form.sub20.c&&form.sub20.e&&form.sub20.f&&!form.sub20.a&&!form.sub20.b&&!form.sub20.d)">
                        Crown
                    </div>
                    <div class="key mt30" v-if="isAdmin&&!(form.sub20.c&&form.sub20.e&&form.sub20.f&&!form.sub20.a&&!form.sub20.b&&!form.sub20.d)">
                        Post and Core
                    </div>
                    <div class="key mt60" v-if="isAdmin&&!(form.sub20.c&&form.sub20.e&&form.sub20.f&&!form.sub20.a&&!form.sub20.b&&!form.sub20.d)">
                        Root canal
                    </div>
                </el-form-item>

                <el-form-item prop="sub21" style="margin-top: 140px">
                    <div class="titleInner"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub21!=1"></el-image>
                        Is there additional treatment necessary for teeth 7 based on the x-rays?</div>
                    <div class="titleInner">
                        <el-select ref="sub21" v-model="form.sub21" placeholder="" class="select" :disabled="isAdmin">
                            <el-option label="Yes" :value="1"></el-option>
                            <el-option label="No" :value="0"></el-option>
                        </el-select>
                    </div>
                    <div class="key" v-if="isAdmin&&form.sub21!=1">
                        Yes
                    </div>
                </el-form-item>

                <el-form-item prop="sub22">
                    <div class="titleInner">If so why, what was done?</div>
                    <el-input ref="sub22" type="textarea" class="textarea" :readonly="isAdmin" v-model="form.sub22"></el-input>
                </el-form-item>

                <el-form-item prop="sub23" class="mt60">
                    <div class="titleInner"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub23!=3"></el-image>
                        What is the patient being considered for?</div>
                    <el-radio-group ref="sub23" v-model="form.sub23" placeholder="" class="radioGroup" :disabled="isAdmin">
                        <el-radio :label="0">Crown</el-radio><br>
                        <el-radio :label="1">Bridge</el-radio><br>
                        <el-radio :label="2">Build up</el-radio><br>
                        <el-radio :label="3">Implant</el-radio><br>
                        <el-radio :label="4">Root canal</el-radio>
                    </el-radio-group>
                    <div class="key" v-if="isAdmin&&form.sub23!=3">
                        Implant
                    </div>
                </el-form-item>
            </div>

            <div class="smallBox" style="min-height: 180px">
                <div class="beakLine" style="height: 20px;line-height: 20px">
                    <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!correctSub12"></el-image>
                    <span >#13</span>
                </div>
                <u class="viewPic" @click="openPic(13)">Radiograph #13</u>
                <el-form-item prop="sub24">
                    <div class="titleInner"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub24!=3"></el-image>
                        Based on the x-rays showing,what treatment was done to replace tooth 7?</div>
                    <el-radio-group ref="sub24" v-model="form.sub24" placeholder="" class="radioGroup" :disabled="isAdmin">
                        <el-radio :label="0">Crown</el-radio><br>
                        <el-radio :label="1">Bridge</el-radio><br>
                        <el-radio :label="2">Build up</el-radio><br>
                        <el-radio :label="3">Implant</el-radio><br>
                        <el-radio :label="4">Root canal</el-radio>
                    </el-radio-group>
                    <div class="key" v-if="isAdmin&&form.sub24!=3">
                        Implant
                    </div>
                </el-form-item>
            </div>

            <div class="smallBox" style="min-height: 320px">
                <div class="beakLine" style="height: 20px;line-height: 20px">
                    <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!correctSub13"></el-image>
                    <span >#14</span>
                </div>
                <u class="viewPic" @click="openPic(14)">Radiograph #14</u>
                <el-form-item prop="sub25" ref="sub25">
                    <div class="titleInner">
                        <el-image :src="wrong" style="width: 20px"
                                  v-if="isAdmin&&!(form.sub25.b&&form.sub25.c&&form.sub25.e&&!form.sub25.a&&!form.sub25.d)"></el-image>
                        Based on the x-ray showing, what treatment was done on tooth 15?</div>
                    <div class="select">
                        <el-checkbox v-model="form.sub25.a" :disabled="isAdmin">Bridge</el-checkbox><br>
                        <el-checkbox v-model="form.sub25.b" :disabled="isAdmin">Build up</el-checkbox><br>
                        <el-checkbox v-model="form.sub25.c" :disabled="isAdmin">Crown</el-checkbox><br>
                        <el-checkbox v-model="form.sub25.d" :disabled="isAdmin">Implant</el-checkbox><br>
                        <el-checkbox v-model="form.sub25.e" :disabled="isAdmin">Root canal</el-checkbox>
                    </div>
                    <div class="key" v-if="isAdmin&&!(form.sub25.b&&form.sub25.c&&form.sub25.e&&!form.sub25.a&&!form.sub25.d)">
                        Crown
                    </div>
                    <div class="key mt30" v-if="isAdmin&&!(form.sub25.b&&form.sub25.c&&form.sub25.e&&!form.sub25.a&&!form.sub25.d)">
                        Build up
                    </div>
                    <div class="key mt60" v-if="isAdmin&&!(form.sub25.b&&form.sub25.c&&form.sub25.e&&!form.sub25.a&&!form.sub25.d)">
                        Root canal
                    </div>
                </el-form-item>

                <el-form-item prop="sub26" style="margin-top: 100px">
                    <div class="titleInner"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub26!=0"></el-image>
                        Would you send this x-ray to insurance as a final x-ray?</div>
                    <div class="titleInner">
                        <el-select ref="sub26" v-model="form.sub26" placeholder="" class="select" :disabled="isAdmin">
                            <el-option label="Yes" :value="1"></el-option>
                            <el-option label="No" :value="0"></el-option>
                        </el-select>
                    </div>
                    <div class="key" v-if="isAdmin&&form.sub26!=0">
                        No
                    </div>
                </el-form-item>

                <el-form-item prop="sub27">
                    <div class="titleInner">Why or why not?</div>
                    <el-input ref="sub27" type="textarea" class="textarea" v-model="form.sub27" :readonly="isAdmin"></el-input>
                </el-form-item>
            </div>

            <div class="smallBox" style="min-height: 180px">
                <div class="beakLine" style="height: 20px;line-height: 20px">
                    <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!correctSub14"></el-image>
                    <span >#15</span>
                </div>
                <u class="viewPic" @click="openPic(15)">Radiograph #15</u>
                <div>Based on the X-rays showing, please answer the following questions:</div>
                <el-form-item prop="sub28">
                    <div class="titleInner"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub28!=0"></el-image>
                        What side of the mouth are you looking at?</div>
                    <el-radio-group ref="sub28" v-model="form.sub28" placeholder="" class="radioGroup" :disabled="isAdmin">
                        <el-radio :label="0">Left</el-radio><br>
                        <el-radio :label="1">Right</el-radio>
                    </el-radio-group>
                    <div class="key" v-if="isAdmin&&form.sub28!=0">
                        Left
                    </div>
                </el-form-item>
                <el-form-item prop="sub29" class="mt40">
                    <div class="titleInner"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub29!=0"></el-image>
                        What type of images were taken?</div>
                    <el-radio-group ref="sub29" v-model="form.sub29" placeholder="" class="radioGroup" :disabled="isAdmin">
                        <el-radio :label="0">Bitewing</el-radio><br>
                        <el-radio :label="1">Panoramic</el-radio><br>
                        <el-radio :label="2">Intra-oral</el-radio><br>
                        <el-radio :label="3">Periapical</el-radio>
                    </el-radio-group>
                    <div class="key" v-if="isAdmin&&form.sub29!=0">
                        Bitewing
                    </div>
                </el-form-item>

                <el-form-item prop="sub30" style="margin-top: 110px">
                    <div class="titleInner"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub30!=0"></el-image>
                        Which X-ray would you send as a final x-ray to insurance for a crown placement on teeth 15?</div>
                    <el-radio-group ref="sub30" v-model="form.sub30" placeholder="" class="radioGroup" :disabled="isAdmin">
                        <el-radio :label="0">Left X-ray</el-radio><br>
                        <el-radio :label="1">Right X-ray</el-radio><br>
                    </el-radio-group>
                    <div class="key" v-if="isAdmin&&form.sub30!=0">
                        Left X-ray
                    </div>
                </el-form-item>

                <el-form-item prop="sub31" class="mt30">
                    <div class="titleInner"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub31!=0"></el-image>
                        Does the patient still have their wisdom teeth?</div>
                    <div class="titleInner">
                        <el-select ref="sub31" v-model="form.sub31" placeholder="" class="select" :disabled="isAdmin">
                            <el-option label="Yes" :value="1"></el-option>
                            <el-option label="No" :value="0"></el-option>
                        </el-select>
                    </div>
                    <div class="key" v-if="isAdmin&&form.sub31!=0">
                        No
                    </div>
                </el-form-item>
            </div>
            <div style="margin-top:10px;margin-bottom: 20px">
                <el-button class="yellowBtn" @click="submitPrepare" v-if="!isAdmin">Submit</el-button>
                <el-button class="grayBtn" @click="cancel">Cancel</el-button>
                <span style="margin-left:10px" v-if="isAdmin">Exam Completed {{ forMateTime(finishDate,true) }}</span>
            </div>
        </el-form>
        <el-dialog :title="titleName" :visible.sync="pdfVisible">
            <div style="text-align: center"><el-image :src="picSrc"></el-image></div>
            <span slot="footer">
                <el-button class="grayBtn" @click="pdfVisible=false">Close</el-button>
            </span>
        </el-dialog>

        <el-dialog title="Confirm" :visible.sync="exitVisible">
            <div>Are you sure you want to cancel the test?</div>
            <span slot="footer">
                <el-button class="yellowBtn" @click="goBack">Yes</el-button>
                <el-button class="grayBtn" @click="exitVisible=false">No</el-button>
            </span>
        </el-dialog>

        <el-dialog title="Confirm" :visible.sync="confirmVisible" width="50%">
            <div style="line-height: 25px;padding: 0 10px;word-wrap:break-word">Caution:this portion of our skills assessment test you are about to view cannot be saved for later. You will
                be scored with no option to return later if you proceed. Do you want to continue?</div>
            <span slot="footer">
                <el-button class="yellowBtn" @click="submit">Yes</el-button>
                <el-button class="grayBtn" @click="confirmVisible=false">No</el-button>
            </span>
        </el-dialog>

        <el-dialog
            title="Assessment Complete"
            :visible.sync="completionDialogVisible"
            :show-close="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            width="50%">
            <div style="text-align: center">
                <p>Thank you for completing this knowledge assessment.</p>
                <p>Please allow up to three business days while we review your application.</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="yellowBtn" @click="handleCompletionConfirm">OK</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import wrong from "../../assets/pic/wrong.png"
    import right from "../../assets/pic/right.png"
    export default {
        name: "EOBExam",
        data(){
            let validateEmptyFive = (rule, value, callback) => {
                // console.log('here')
                if (!value.a&&!value.b&&!value.c&&!value.d&&!value.e) {
                    callback(new Error('Required'))
                } else {
                    callback()
                }
            }
            let validateEmptyEight = (rule, value, callback) => {
                if (!value.a&&!value.b&&!value.c&&!value.d&&!value.e&&!value.f&&!value.g&&!value.h) {
                    callback(new Error('Required'))
                } else {
                    callback()
                }
            }
            let validateEmptySix = (rule, value, callback) => {
                if (!value.a&&!value.b&&!value.c&&!value.d&&!value.e&&!value.f) {
                    callback(new Error('Required'))
                } else {
                    callback()
                }
            }
            return{
                finishDate:'',
                getScore:0,
                correctNum:0,
                totalNum:35,
                showResult:true,
                hasFinished:false,
                //testData:["Bridge|Build up|Crown|Implant|Root canal", "Panoramic", 1, "Bitewing", "Child", "Bridge|Build up|Crown|Implant|Root canal", 1, "421f", "Right", "2123", 0, "12312", "Build up|Crown|Implant|Root canal", "7|8|9|10", "8|12", "Bitewing", "4cewdc", "Splint", "Lower", "Root canal", "Build up|Crown|Post and Core", 0, "5332", "Bridge", "Implant", "Build up|Implant", 1, "vvfddw", "Right", "Panoramic", "Left X-ray", 0],
                wrong:wrong,
                right:right,
                pdfVisible:false,
                exitVisible:false,
                confirmVisible:false,
                pdfLoading:false,
                picSrc:'',
                titleName:'',
                isAdmin:false,
                completionDialogVisible: false,
                scores:[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
                details:[[],[],[],[],[],[],[],[],[],[],[],[],[],[],[]],
                possibles:[1,2,2,3,1,1,2,5,1,2,1,5,1,4,4],
                form:{
                    sub0:{
                        // a:true
                    },
                    // sub1:1,
                    sub2:0,
                    // sub3:0,
                    // sub4:0,
                    sub5:{
                        // b:true,
                        // e:true
                    },
                    sub6:0,
                    sub7:'',//输入框textarea
                    sub9:'',//输入框textarea
                    sub10:0,
                    sub11:'',
                    sub12:{
                        // c:true,
                        // d:true,
                        // e:true,
                        // f:true
                    },
                    sub13:{
                        // d:true
                    },
                    sub14:{
                        // d:true
                    },
                    // sub14:2,
                     sub16:'',
                    // sub17:1,
                    // sub18:3,
                    sub20:{},
                    sub21:0,
                     sub22:'',
                    // sub23:3,
                    sub25:{},
                    sub26:0,
                     sub27:'',
                    // sub28:0,
                    // sub29:0,
                    sub31:0,
                },
                rules:{
                    sub0:[{required: true, message: 'Required', trigger: 'blur'},
                        {validator:validateEmptyFive,trigger: 'blur'}],
                    sub1:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub3:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub4:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub5:[{required: true, message: 'Required', trigger: 'blur'},
                        {validator:validateEmptyFive,trigger: 'blur'}],
                    sub8:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub12:[{required: true, message: 'Required', trigger: 'blur'},
                        {validator:validateEmptyFive,trigger: 'blur'}],
                    sub13:[{required: true, message: 'Required', trigger: 'blur'},
                        {validator:validateEmptyEight,trigger: 'blur'}],
                    sub14:[{required: true, message: 'Required', trigger: 'blur'},
                        {validator:validateEmptyEight,trigger: 'blur'}],
                    sub15:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub17:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub18:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub19:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub20:[{required: true, message: 'Required', trigger: 'blur'},
                        {validator:validateEmptySix,trigger: 'blur'}],
                    sub23:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub24:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub25:[{required: true, message: 'Required', trigger: 'blur'},
                        {validator:validateEmptyFive,trigger: 'blur'}],
                    sub28:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub29:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub30:[{required: true, message: 'Required', trigger: 'blur'}],
                },
            }
        },
        computed:{
            /**根据用户自己选择算出正确率**/
            correctPercent(){
                return (this.getScore*100/this.totalNum).toFixed(2)+'%'
            },
            correctSub0(){
                return this.form.sub0.a&&!this.form.sub0.b&&!this.form.sub0.c&&!this.form.sub0.d&&!this.form.sub0.e
            },
            correctSub1(){
                return this.form.sub1==1&&this.form.sub2==1
            },
            correctSub2(){
                return this.form.sub3==0&&this.form.sub4==1
            },
            correctSub3(){
                var res5 = this.form.sub5.b&&this.form.sub5.e&&!this.form.sub5.a&&!this.form.sub5.c&&!this.form.sub5.d
                return res5&&this.form.sub6==1
            },
            correctSub4(){
                return this.form.sub8==1
            },
            correctSub5(){
                return this.form.sub10==0
            },
            correctSub6(){
                return this.form.sub12.b&&this.form.sub12.e&&!this.form.sub12.a&&!this.form.sub12.c&&!this.form.sub12.d
            },
            correctSub7(){
                var res13 = !this.form.sub13.a&&!this.form.sub13.b&&this.form.sub13.c&&this.form.sub13.d&&this.form.sub13.e
                &&this.form.sub13.f&&!this.form.sub13.g&&!this.form.sub13.h
                var res14 = !this.form.sub14.a&&!this.form.sub14.b&&!this.form.sub14.c&&this.form.sub14.d&&!this.form.sub14.e
                    &&!this.form.sub14.f&&!this.form.sub14.g&&!this.form.sub14.h
                return res13&&res14
            },
            correctSub8(){
                return this.form.sub15==2
            },
            correctSub9(){
                return this.form.sub17==0&&this.form.sub18==1
            },
            correctSub10(){
                return this.form.sub19==3
            },
            correctSub11(){
                var res20= this.form.sub20.c&&this.form.sub20.e&&this.form.sub20.f&&!this.form.sub20.a&&!this.form.sub20.b&&!this.form.sub20.d
                return res20&&this.form.sub21==1&&this.form.sub23==3
            },
            correctSub12(){
                return this.form.sub24==3
            },
            correctSub13(){
                var res25 = this.form.sub25.b&&this.form.sub25.c&&this.form.sub25.e&&!this.form.sub25.a&&!this.form.sub25.d
                return res25&&this.form.sub26==0
            },
            correctSub14(){
                return this.form.sub28==0&&this.form.sub29==0&&this.form.sub30==0&&this.form.sub31==0
            }

        },
        methods:{
            deconstructData(data){
                // console.log('RadioGraphy',data);
                if(!data)return
                // var jsonData = JSON.parse(data)
                var jsonData = data.detail||[]
                this.finishDate = data.finishDate ||''
                if(jsonData.length!=15){
                    // console.log('答题数据错误')
                    return
                }
                for(var i=0;i<jsonData.length;i++){
                    var item = jsonData[i].detail
                    for(var j =0;j<item.length;j++){
                        var child = item[j]
                        if(i==0){
                            if(j==0){
                                if(child.indexOf('Bridge')>=0)this.form['sub'+j].a=true
                                if(child.indexOf('Build up')>=0)this.form['sub'+j].b=true
                                if(child.indexOf('Crown')>=0)this.form['sub'+j].c=true
                                if(child.indexOf('Implant')>=0)this.form['sub'+j].d=true
                                if(child.indexOf('Root canal')>=0)this.form['sub'+j].e=true
                            }
                        }else if(i==1){
                            if(j<2){
                                if(j==0){
                                    if(child=='Bitewing')this.form['sub'+(1+j)]=0
                                    else if(child=='Panoramic')this.form['sub'+(1+j)]=1
                                    else if(child=='Intra-oral')this.form['sub'+(1+j)]=2
                                    else if(child=='Periapical')this.form['sub'+(1+j)]=3
                                }else{
                                    this.form['sub'+(1+j)]=child
                                }
                            }
                        }else if(i==2){
                            if(j<2){
                                if(j==0){
                                    if(child=='Bitewing')this.form['sub'+(3+j)]=0
                                    else if(child=='Panoramic')this.form['sub'+(3+j)]=1
                                    else if(child=='Intra-oral')this.form['sub'+(3+j)]=2
                                    else if(child=='Periapical')this.form['sub'+(3+j)]=3
                                }else{
                                    if(child=='Adult')this.form['sub'+(3+j)]=0
                                    else if(child=='Child')this.form['sub'+(3+j)]=1
                                }
                            }
                        }else if(i==3){
                            if(j<3){
                                if(j==0){
                                    if(child.indexOf('Bridge')>=0)this.form['sub'+(5+j)].a=true
                                    if(child.indexOf('Build up')>=0)this.form['sub'+(5+j)].b=true
                                    if(child.indexOf('Crown')>=0)this.form['sub'+(5+j)].c=true
                                    if(child.indexOf('Implant')>=0)this.form['sub'+(5+j)].d=true
                                    if(child.indexOf('Root canal')>=0)this.form['sub'+(5+j)].e=true
                                }else{
                                    this.form['sub'+(5+j)]=child
                                }
                            }
                        }else if(i==4){
                            if(j<2){
                                if(j==0){
                                    if(child=='Left')this.form['sub'+(8+j)]=0
                                    else if(child=='Right')this.form['sub'+(8+j)]=1
                                }else{
                                    this.form['sub'+(8+j)]=child
                                }
                            }
                        }else if(i==5){
                            if(j<2)this.form['sub'+(10+j)]=child
                        }else if(i==6){//12
                            if(j==0){
                                if(child.indexOf('Bridge')>=0)this.form['sub'+(12+j)].a=true
                                if(child.indexOf('Build up')>=0)this.form['sub'+(12+j)].b=true
                                if(child.indexOf('Crown')>=0)this.form['sub'+(12+j)].c=true
                                if(child.indexOf('Implant')>=0)this.form['sub'+(12+j)].d=true
                                if(child.indexOf('Root canal')>=0)this.form['sub'+(12+j)].e=true
                            }
                        }else if(i==7){//13,14
                            if(j<2){
                                if(child.indexOf('5')>=0)this.form['sub'+(13+j)].a=true
                                if(child.indexOf('6')>=0)this.form['sub'+(13+j)].b=true
                                if(child.indexOf('7')>=0)this.form['sub'+(13+j)].c=true
                                if(child.indexOf('8')>=0)this.form['sub'+(13+j)].d=true
                                if(child.indexOf('9')>=0)this.form['sub'+(13+j)].e=true
                                if(child.indexOf('10')>=0)this.form['sub'+(13+j)].f=true
                                if(child.indexOf('11')>=0)this.form['sub'+(13+j)].g=true
                                if(child.indexOf('12')>=0)this.form['sub'+(13+j)].h=true
                            }
                        }else if(i==8){//15,16
                            if(j<2){
                                if(j==0){
                                    if(child=='Bitewing')this.form['sub'+(15+j)]=0
                                    else if(child=='Panoramic')this.form['sub'+(15+j)]=1
                                    else if(child=='Intra-oral')this.form['sub'+(15+j)]=2
                                    else if(child=='Periapical')this.form['sub'+(15+j)]=3
                                }else{
                                    this.form['sub'+(15+j)]=child
                                }
                            }
                        }else if(i==9){//17.18
                            if(j<2){
                                if(j==0){
                                    if(child=='Permanent retainer')this.form['sub'+(17+j)]=0
                                    else if(child=='Braces')this.form['sub'+(17+j)]=1
                                    else if(child=='MonoBlock')this.form['sub'+(17+j)]=2
                                    else if(child=='Splint')this.form['sub'+(17+j)]=3
                                }else{
                                    if(child=='Upper')this.form['sub'+(17+j)]=0
                                    else if(child=='Lower')this.form['sub'+(17+j)]=1
                                }
                            }
                        }else if(i==10){//19
                            if(j==0){
                                if(child=='Crown')this.form['sub'+(19+j)]=0
                                else if(child=='Composite filling')this.form['sub'+(19+j)]=1
                                else if(child=='Build up')this.form['sub'+(19+j)]=2
                                else if(child=='Amalgam filling')this.form['sub'+(19+j)]=3
                                else if(child=='Root canal')this.form['sub'+(19+j)]=4
                            }
                        }else if(i==11){//20,21,22,23
                            if(j<4){
                                if(j==0){
                                    if(child.indexOf('Bridge')>=0)this.form['sub'+(20+j)].a=true
                                    if(child.indexOf('Build up')>=0)this.form['sub'+(20+j)].b=true
                                    if(child.indexOf('Crown')>=0)this.form['sub'+(20+j)].c=true
                                    if(child.indexOf('Implant')>=0)this.form['sub'+(20+j)].d=true
                                    if(child.indexOf('Post and Core')>=0)this.form['sub'+(20+j)].e=true
                                    if(child.indexOf('Root canal')>=0)this.form['sub'+(20+j)].f=true
                                }else if(j==3){
                                    if(child=='Crown')this.form['sub'+(20+j)]=0
                                    else if(child=='Bridge')this.form['sub'+(20+j)]=1
                                    else if(child=='Build up')this.form['sub'+(20+j)]=2
                                    else if(child=='Implant')this.form['sub'+(20+j)]=3
                                    else if(child=='Root canal')this.form['sub'+(20+j)]=4
                                }else{
                                    this.form['sub'+(20+j)]=child
                                }
                            }
                        }else if(i==12){//24
                            if(j==0){
                                if(child=='Crown')this.form['sub'+(24+j)]=0
                                else if(child=='Bridge')this.form['sub'+(24+j)]=1
                                else if(child=='Build up')this.form['sub'+(24+j)]=2
                                else if(child=='Implant')this.form['sub'+(24+j)]=3
                                else if(child=='Root canal')this.form['sub'+(24+j)]=4
                            }
                        }else if(i==13){//25,26,27
                            if(j<3){
                                if(j==0){
                                    if(child.indexOf('Bridge')>=0)this.form['sub'+(25+j)].a=true
                                    if(child.indexOf('Build up')>=0)this.form['sub'+(25+j)].b=true
                                    if(child.indexOf('Crown')>=0)this.form['sub'+(25+j)].c=true
                                    if(child.indexOf('Implant')>=0)this.form['sub'+(25+j)].d=true
                                    if(child.indexOf('Root canal')>=0)this.form['sub'+(25+j)].e=true
                                }else{
                                    this.form['sub'+(25+j)]=child
                                }
                            }
                        }else if(i==14){//28,29,30,31
                            if(j<4){
                                if(j==0){
                                    if(child=='Left')this.form['sub'+(28+j)]=0
                                    else if(child=='Right')this.form['sub'+(28+j)]=1
                                }else if(j==1){
                                    if(child=='Bitewing')this.form['sub'+(28+j)]=0
                                    else if(child=='Panoramic')this.form['sub'+(28+j)]=1
                                    else if(child=='Intra-oral')this.form['sub'+(28+j)]=2
                                    else if(child=='Periapical')this.form['sub'+(28+j)]=3
                                }else if(j==2){
                                    if(child=='Left X-ray')this.form['sub'+(28+j)]=0
                                    if(child=='Right X-ray')this.form['sub'+(28+j)]=1
                                }else{
                                    this.form['sub'+(28+j)]=child
                                }
                            }
                        }
                    }
                }
                this.calScore()
            },
            calScore(){
                this.scores=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
                //#1
                if(this.form.sub0.a)this.scores[0]++
                if(this.form.sub0.b)this.scores[0]--
                if(this.form.sub0.c)this.scores[0]--
                if(this.form.sub0.d)this.scores[0]--
                if(this.form.sub0.e)this.scores[0]--
                if(this.form.sub0.a&&!this.form.sub0.b&&!this.form.sub0.c&&!this.form.sub0.d&&!this.form.sub0.e){
                    this.correctNum++
                }
                //#2
                if(this.form.sub1==1){this.scores[1]++; this.correctNum++}
                if(this.form.sub2==1){this.scores[1]++; this.correctNum++}
                //#3
                if(this.form.sub3==0){this.scores[2]++; this.correctNum++}
                if(this.form.sub4==1){this.scores[2]++; this.correctNum++}

                //#4
                if(this.form.sub5.a)this.scores[3]--
                if(this.form.sub5.b)this.scores[3]++
                if(this.form.sub5.c)this.scores[3]--
                if(this.form.sub5.d)this.scores[3]--
                if(this.form.sub5.e)this.scores[3]++
                if(!this.form.sub5.a&&this.form.sub5.b&&!this.form.sub5.c&&!this.form.sub5.d&&this.form.sub5.e)this.correctNum++

                if(this.form.sub6==1){this.scores[3]++;this.correctNum++}
                //#5
                if(this.form.sub8==1){this.scores[4]++;this.correctNum++}
                //#6
                if(this.form.sub10==0){this.scores[5]++;this.correctNum++}
                //#7
                if(this.form.sub12.a)this.scores[6]--
                if(this.form.sub12.b)this.scores[6]++
                if(this.form.sub12.c)this.scores[6]--
                if(this.form.sub12.d)this.scores[6]--
                if(this.form.sub12.e)this.scores[6]++
                if(!this.form.sub12.a&&this.form.sub12.b&&!this.form.sub12.c&&!this.form.sub12.d&&this.form.sub12.e)this.correctNum++
                //#8
                if(this.form.sub13.a)this.scores[7]--
                if(this.form.sub13.b)this.scores[7]--
                if(this.form.sub13.c)this.scores[7]++
                if(this.form.sub13.d)this.scores[7]++
                if(this.form.sub13.e)this.scores[7]++
                if(this.form.sub13.f)this.scores[7]++
                if(this.form.sub13.g)this.scores[7]--
                if(this.form.sub13.h)this.scores[7]--
                if(!this.form.sub13.a&&!this.form.sub13.b&&this.form.sub13.c&&this.form.sub13.d&&this.form.sub13.e&&
                    this.form.sub13.f&& !this.form.sub13.g&&!this.form.sub13.h){
                    this.correctNum++
                }

                if(this.form.sub14.a)this.scores[7]--
                if(this.form.sub14.b)this.scores[7]--
                if(this.form.sub14.c)this.scores[7]--
                if(this.form.sub14.d)this.scores[7]++
                if(this.form.sub14.e)this.scores[7]--
                if(this.form.sub14.f)this.scores[7]--
                if(this.form.sub14.g)this.scores[7]--
                if(this.form.sub14.h)this.scores[7]--
                if(!this.form.sub14.a&&!this.form.sub14.b&&!this.form.sub14.c&&this.form.sub14.d&&!this.form.sub14.e&&
                    !this.form.sub14.f&& !this.form.sub14.g&&!this.form.sub14.h){
                    this.correctNum++
                }
                //#9
                if(this.form.sub15==2){this.scores[8]++;this.correctNum++}
                //#10
                if(this.form.sub17==0){this.scores[9]++;this.correctNum++}
                if(this.form.sub18==1){this.scores[9]++;this.correctNum++}
                //#11
                if(this.form.sub19==3){this.scores[10]++;this.correctNum++}
                //#12
                if(this.form.sub20.a)this.scores[11]--
                if(this.form.sub20.b)this.scores[11]--
                if(this.form.sub20.c)this.scores[11]++
                if(this.form.sub20.d)this.scores[11]--
                if(this.form.sub20.e)this.scores[11]++
                if(this.form.sub20.f)this.scores[11]++
                if(!this.form.sub20.a&&!this.form.sub20.b&&this.form.sub20.c&&!this.form.sub20.d&&this.form.sub20.e&&this.form.sub20.f){
                    this.correctNum++
                }
                if(this.form.sub21==1){this.scores[11]++;this.correctNum++}
                if(this.form.sub23==3){this.scores[11]++;this.correctNum++}
                //#13
                if(this.form.sub24==3){this.scores[12]++;this.correctNum++}
                //#14
                if(this.form.sub25.a)this.scores[13]--
                if(this.form.sub25.b)this.scores[13]++
                if(this.form.sub25.c)this.scores[13]++
                if(this.form.sub25.d)this.scores[13]--
                if(this.form.sub25.e)this.scores[13]++
                if(!this.form.sub25.a&&this.form.sub25.b&&this.form.sub25.c&&!this.form.sub25.d&&this.form.sub25.e){
                    this.correctNum++
                }
                if(this.form.sub26==0){this.scores[13]++;this.correctNum++}
                //#15
                if(this.form.sub28==0){this.scores[14]++;this.correctNum++}
                if(this.form.sub29==0){this.scores[14]++;this.correctNum++}
                if(this.form.sub30==1){this.scores[14]++;this.correctNum++}
                if(this.form.sub31==0){this.scores[14]++;this.correctNum++}
                var goal=0
                this.scores.forEach(item=>{
                    goal+=item
                })
                this.getScore = goal
            },
            rebuildData(){//重构测试通过
                this.details = [[],[],[],[],[],[],[],[],[],[],[],[],[],[],[]]
                for(var i=0;i<32;i++){
                    if(i==0){
                        var templist=[],str
                        if(this.form['sub'+i].a)templist.push('Bridge')
                        if(this.form['sub'+i].b)templist.push('Build up')
                        if(this.form['sub'+i].c)templist.push('Crown')
                        if(this.form['sub'+i].d)templist.push('Implant')
                        if(this.form['sub'+i].e)templist.push('Root canal')
                        str = templist.join("|")
                        this.details[0].push(str)
                    }else if(i>0&&i<3){
                        if(i==1){
                            if(this.form['sub'+i]==0)this.details[1].push('Bitewing')
                            if(this.form['sub'+i]==1)this.details[1].push('Panoramic')
                            if(this.form['sub'+i]==2)this.details[1].push('Intra-oral')
                            if(this.form['sub'+i]==3)this.details[1].push('Periapical')
                        }else{
                            this.details[1].push(this.form['sub'+i])
                        }

                    }else if(i>=3&&i<5){
                        if(i==3){
                            if(this.form['sub'+i]==0)this.details[2].push('Bitewing')
                            if(this.form['sub'+i]==1)this.details[2].push('Panoramic')
                            if(this.form['sub'+i]==2)this.details[2].push('Intra-oral')
                            if(this.form['sub'+i]==3)this.details[2].push('Periapical')
                        }else{
                            if(this.form['sub'+i]==0)this.details[2].push('Adult')
                            if(this.form['sub'+i]==1)this.details[2].push('Child')
                        }
                    }else if(i>=5&&i<8){
                        if(i==5){
                            var templist1=[],str1
                            if(this.form['sub'+i].a)templist1.push('Bridge')
                            if(this.form['sub'+i].b)templist1.push('Build up')
                            if(this.form['sub'+i].c)templist1.push('Crown')
                            if(this.form['sub'+i].d)templist1.push('Implant')
                            if(this.form['sub'+i].e)templist1.push('Root canal')
                            str1 = templist1.join("|")
                            this.details[3].push(str1)
                        }else{
                            this.details[3].push(this.form['sub'+i])
                        }
                    }else if(i>=8&&i<10){
                        if(i==8){
                            if(this.form['sub'+i]==0)this.details[4].push('Left')
                            else if(this.form['sub'+i]==1)this.details[4].push('Right')
                        }else{
                            this.details[4].push(this.form['sub'+i])
                        }
                    }else if(i>=10&&i<12){
                        this.details[5].push(this.form['sub'+i])
                    }else if(i==12){
                        var templist2=[],str2
                        if(this.form['sub'+i].a)templist2.push('Bridge')
                        if(this.form['sub'+i].b)templist2.push('Build up')
                        if(this.form['sub'+i].c)templist2.push('Crown')
                        if(this.form['sub'+i].d)templist2.push('Implant')
                        if(this.form['sub'+i].e)templist2.push('Root canal')
                        str2 = templist2.join("|")
                        this.details[6].push(str2)
                    }else if(i>=13&&i<15){
                        var templist13=[],str13
                        if(this.form['sub'+i].a)templist13.push('5')
                        if(this.form['sub'+i].b)templist13.push('6')
                        if(this.form['sub'+i].c)templist13.push('7')
                        if(this.form['sub'+i].d)templist13.push('8')
                        if(this.form['sub'+i].e)templist13.push('9')
                        if(this.form['sub'+i].f)templist13.push('10')
                        if(this.form['sub'+i].g)templist13.push('11')
                        if(this.form['sub'+i].h)templist13.push('12')
                        str13 = templist13.join('|')
                        this.details[7].push(str13)
                    }else if(i>=15&&i<17){
                        if(i==15){
                            if(this.form['sub'+i]==0)this.details[8].push('Bitewing')
                            if(this.form['sub'+i]==1)this.details[8].push('Panoramic')
                            if(this.form['sub'+i]==2)this.details[8].push('Intra-oral')
                            if(this.form['sub'+i]==3)this.details[8].push('Periapical')
                        }else{
                            this.details[8].push(this.form['sub'+i])
                        }
                    }else if(i>=17&&i<19){
                        if(i==17){
                            if(this.form['sub'+i]==0)this.details[9].push('Permanent retainer')
                            if(this.form['sub'+i]==1)this.details[9].push('Braces')
                            if(this.form['sub'+i]==2)this.details[9].push('MonoBlock')
                            if(this.form['sub'+i]==3)this.details[9].push('Splint')
                        }else{
                            if(this.form['sub'+i]==0)this.details[9].push('Upper')
                            if(this.form['sub'+i]==1)this.details[9].push('Lower')
                        }
                    }else if(i==19){
                        if(this.form['sub'+i]==0)this.details[10].push('Crown')
                        if(this.form['sub'+i]==1)this.details[10].push('Composite filling')
                        if(this.form['sub'+i]==2)this.details[10].push('Build up')
                        if(this.form['sub'+i]==3)this.details[10].push('Amalgam filling')
                        if(this.form['sub'+i]==4)this.details[10].push('Root canal')
                    }else if(i>=20&&i<24){
                        if(i==20){
                            var tempList20=[],str20
                            if(this.form['sub'+i].a)tempList20.push('Bridge')
                            if(this.form['sub'+i].b)tempList20.push('Build up')
                            if(this.form['sub'+i].c)tempList20.push('Crown')
                            if(this.form['sub'+i].d)tempList20.push('Implant')
                            if(this.form['sub'+i].e)tempList20.push('Post and Core')
                            if(this.form['sub'+i].f)tempList20.push('Root canal')
                            str20 = tempList20.join('|')
                            this.details[11].push(str20)
                        }else if(i==23){
                            if(this.form['sub'+i]==0) this.details[11].push('Crown')
                            if(this.form['sub'+i]==1) this.details[11].push('Bridge')
                            if(this.form['sub'+i]==2) this.details[11].push('Build up')
                            if(this.form['sub'+i]==3) this.details[11].push('Implant')
                            if(this.form['sub'+i]==4) this.details[11].push('Root canal')
                        }else{
                            this.details[11].push(this.form['sub'+i])
                        }
                    }else if(i==24){
                        if(this.form['sub'+i]==0) this.details[12].push('Crown')
                        if(this.form['sub'+i]==1) this.details[12].push('Bridge')
                        if(this.form['sub'+i]==2) this.details[12].push('Build up')
                        if(this.form['sub'+i]==3) this.details[12].push('Implant')
                        if(this.form['sub'+i]==4) this.details[12].push('Root canal')
                    }else if(i>=25&&i<28){
                        if(i==25){
                            var templist3=[],str3
                            if(this.form['sub'+i].a)templist3.push('Bridge')
                            if(this.form['sub'+i].b)templist3.push('Build up')
                            if(this.form['sub'+i].c)templist3.push('Crown')
                            if(this.form['sub'+i].d)templist3.push('Implant')
                            if(this.form['sub'+i].e)templist3.push('Root canal')
                            str3 = templist3.join("|")
                            this.details[13].push(str3)
                        }else{
                            this.details[13].push(this.form['sub'+i])
                        }
                    }else if(i>=28&&i<32){
                        if(i==28){
                            if(this.form['sub'+i]==0)this.details[14].push('Left')
                            if(this.form['sub'+i]==1)this.details[14].push('Right')
                        } else if(i==29){
                            if(this.form['sub'+i]==0)this.details[14].push('Bitewing')
                            if(this.form['sub'+i]==1)this.details[14].push('Panoramic')
                            if(this.form['sub'+i]==2)this.details[14].push('Intra-oral')
                            if(this.form['sub'+i]==3)this.details[14].push('Periapical')
                        }else if(i==30){
                            if(this.form['sub'+i]==0)this.details[14].push('Left X-ray')
                            if(this.form['sub'+i]==1)this.details[14].push('Right X-ray')
                        }else{
                            this.details[14].push(this.form['sub'+i])
                        }

                    }
                //     if(i==0||i==5||i==12||i==25){
                //         var templist=[],str
                //         if(this.form['sub'+i].a)templist.push('Bridge')
                //         if(this.form['sub'+i].b)templist.push('Build up')
                //         if(this.form['sub'+i].c)templist.push('Crown')
                //         if(this.form['sub'+i].d)templist.push('Implant')
                //         if(this.form['sub'+i].e)templist.push('Root canal')
                //         str = templist.join("|")
                //         list.push(str)
                //     }else if(i==1||i==3||i==15||i==29){
                //         if(this.form['sub'+i]==0)list.push('Bitewing')
                //         if(this.form['sub'+i]==1)list.push('Panoramic')
                //         if(this.form['sub'+i]==2)list.push('Intra-oral')
                //         if(this.form['sub'+i]==3)list.push('Periapical')
                //     }else if(i==4){
                //         if(this.form['sub'+i]==0)list.push('Adult')
                //         if(this.form['sub'+i]==1)list.push('Child')
                //     }else if(i==8||i==28){
                //         if(this.form['sub'+i]==0)list.push('Left')
                //         if(this.form['sub'+i]==1)list.push('Right')
                //     }else if(i==13||i==14){
                //         var templist13=[],str13
                //         if(this.form['sub'+i].a)templist13.push('5')
                //         if(this.form['sub'+i].b)templist13.push('6')
                //         if(this.form['sub'+i].c)templist13.push('7')
                //         if(this.form['sub'+i].d)templist13.push('8')
                //         if(this.form['sub'+i].e)templist13.push('9')
                //         if(this.form['sub'+i].f)templist13.push('10')
                //         if(this.form['sub'+i].g)templist13.push('11')
                //         if(this.form['sub'+i].h)templist13.push('12')
                //         str13 = templist13.join('|')
                //         list.push(str13)
                //     }else if(i==17){
                //         if(this.form['sub'+i]==0)list.push('Permanent retainer')
                //         if(this.form['sub'+i]==1)list.push('Braces')
                //         if(this.form['sub'+i]==2)list.push('MonoBlock')
                //         if(this.form['sub'+i]==3)list.push('Splint')
                //     }else if(i==18){
                //         if(this.form['sub'+i]==0)list.push('Upper')
                //         if(this.form['sub'+i]==1)list.push('Lower')
                //     }else if(i==19){
                //         if(this.form['sub'+i]==0)list.push('Crown')
                //         if(this.form['sub'+i]==1)list.push('Composite filling')
                //         if(this.form['sub'+i]==2)list.push('Build up')
                //         if(this.form['sub'+i]==3)list.push('Amalgam filling')
                //         if(this.form['sub'+i]==4)list.push('Root canal')
                //     }else if(i==20){
                //         var tempList20=[],str20
                //         if(this.form['sub'+i].a)tempList20.push('Bridge')
                //         if(this.form['sub'+i].b)tempList20.push('Build up')
                //         if(this.form['sub'+i].c)tempList20.push('Crown')
                //         if(this.form['sub'+i].d)tempList20.push('Implant')
                //         if(this.form['sub'+i].e)tempList20.push('Post and Core')
                //         if(this.form['sub'+i].f)tempList20.push('Root canal')
                //         str20 = tempList20.join('|')
                //         list.push(str20)
                //     }else if(i==23||i==24){
                //         if(this.form['sub'+i]==0)list.push('Crown')
                //         if(this.form['sub'+i]==1)list.push('Bridge')
                //         if(this.form['sub'+i]==2)list.push('Build up')
                //         if(this.form['sub'+i]==3)list.push('Implant')
                //         if(this.form['sub'+i]==4)list.push('Root canal')
                //     }else if(i==30){
                //         if(this.form['sub'+i]==0)list.push('Left X-ray')
                //         if(this.form['sub'+i]==1)list.push('Right X-ray')
                //     }else list.push(this.form['sub'+i])
                }
                // return list
            },
            /**打开图片文件**/
            openPic(index){
                // console.log(index)
                this.pdfVisible=true
                 this.titleName="Capture"+index+".jpg"
                 this.picSrc=require('../../assets/file/RadiographyExam/Capture'+index+'.jpg')

            },
            goBack(){
                this.$router.push({path:'/service'})
            },
            goPre(){
                this.$router.go(-1)
            },
            submit(){
                this.confirmVisible=false
                var paramsList =[]
                var score=0,possible=0
                this.rebuildData()
                // console.log('传递的参数',this.details)
                this.calScore()
                for(var i=0;i<15;i++){
                    var obj={}
                    obj.score = this.scores[i]
                    obj.possible = this.possibles[i]
                    obj.detail = this.details[i]
                    paramsList.push(obj)
                }
                score= this.scores.reduce(function(sum,number){ //sum2 前两个数的和
                    return sum + number;
                },0)
                possible= this.possibles.reduce(function(sum,number){ //sum2 前两个数的和
                    return sum + number;
                },0)
                var storeService = this.$store.state.serviceInfo
               // var positionInfo = this.$store.state.positionInfo
                var params={}
                params.serviceId =storeService.serviceId
                params.versionId = storeService.serviceVersion
                params.score = score
                params.possible = possible
                params.type='Radiography'
                params.positionId = 0
                params.detail = JSON.stringify(paramsList)
                params.applicantEmail=localStorage.getItem('email')
                this.pdfLoading = true
                this.$axios.post(this.$URL.dentalbillingUrl,params).then(res=>{
                    this.pdfLoading = false
                    if(res.code==0){
                        var finishModule = this.$store.state.finished
                        finishModule['Radio']=1
                        this.showResult=true
                        this.$store.commit('saveFinishModule',finishModule)
                        this.nextStep()
                    }else{
                        this.$message.error({message:res.msg})
                    }
                }).catch(err=>{
                    this.pdfLoading = false
                    this.$message.error({message:err})
                })
            },
            nextStep(){//检测其他两项有没有做完测试，没有就激活其他的tab页，把当前做完测试得tab置为测试完成状态，并把当前滚到顶端
                var flags = this.$store.state.finished
                if(flags['EOB']==0){
                    this.$emit('changeIndex','0')
                    this.$emit('changeGraphyStatus')
                    window.scrollTo(0,0);
                }else if(flags['Claim']==0){
                    this.$emit('changeIndex','2')
                    this.$emit('changeGraphyStatus')
                    window.scrollTo(0,0);
                }else{
                    this.completionDialogVisible = true
                }
            },
            handleCompletionConfirm() {
                this.completionDialogVisible = false
                this.goBack()
            },
            submitPrepare(){
                this.$refs['form'].clearValidate()
                this.$nextTick(() => {
                    this.$refs['form'].validate((valid,object) => {
                        if (valid) {
                            // console.log('submit',this.form)
                           this.confirmVisible=true
                        }else {
                            var obj = Object.keys(object)[0]
                            let dom = this.$refs[obj]
                            dom.$el.scrollIntoView({
                                //滚动到指定节点
                                block: 'center', //值有start,center,end，nearest，当前显示在视图区域中间
                                behavior: 'smooth' //值有auto、instant,smooth，缓动动画（当前是慢速的）
                            })
                            // console.log('error submit!!');
                            return false;
                        }
                    })
                })
            },
            cancel(){
                this.exitVisible=true
            },
            getRadioGraphyData(email){
                this.pdfLoading = true
                this.$axios.get(this.$URL.dentalbillingUrl,{params:{email:email,type:'Radiography'}}).then(res=>{
                    this.pdfLoading = false
                    if(res&&res.code==0){
                        this.hasFinished=true
                        var data = res.data
                        var finishModule = this.$store.state.finished
                        if(data&&data.detail!=null){
                            finishModule['Radio']=1
                            // console.log('Radio 测试已经做了！')
                            if(this.isAdmin)this.showResult=false
                            else this.showResult=true
                            this.deconstructData(data)
                            this.$emit('changeStatus')
                        }else{
                            finishModule['Radio']=0
                            this.showResult=false
                            // console.log('Radio 测试还没做！')
                        }
                        this.$store.commit('saveFinishModule',finishModule)
                        // console.log('已做过3',this.$store.state.finished)
                    }else{
                        this.$message.error({message:res.msg})
                    }
                }).catch(err=>{
                    this.pdfLoading = false
                    this.$message.error({message:err})
                })
            }
        },
        created() {
            var email
            if(this.$route&&this.$route.query.model=='review'&&this.$route.query.verify){
                this.isAdmin=true
                email = this.$route.query.email
                this.showResult=false
            }else{
                email = localStorage.getItem('email')
                this.isAdmin=false
                this.showResult=false
            }
            this.getRadioGraphyData(email)

        }
    }
</script>

<style scoped>
    .el-select >>> .el-input{
        width: 68px;
    }
    .el-select >>> .el-input .el-input__inner{
        background: #fff!important;
        font-size: 12px!important;
        line-height: 40px!important;
        border-radius: 0px!important;
        height: 30px!important;
    }
    .el-select >>> .el-input .el-input__icon{
        width: 15px!important;
    }
    .el-radio{
        height: 20px!important;
    }
    .smallBox >>>.el-form-item__content{
        line-height: 25px!important;
    }
    .minH150{
        min-height: 150px;
    }

    .minH200{
        min-height: 150px;
    }
    .titleInner{
        width: 35%;
        line-height: 20px;
        margin-top: 10px
    }
    .textarea{
        resize:none;
        width: 30%;
        position: absolute;
        top:20px;
        margin-left: 37%;
        height: 50px
    }
    .radioGroup{
        position: absolute;
        top:0px;
        margin-left: 37%
    }
    .select{
        position: absolute;
        top:8px;
        margin-left: 37%
    }
    .el-image{
        overflow: inherit;
    }
    .key{
        border: 1px solid red;
        width: 20%;
        position: absolute;
        top: 20px;
        right: 20px;
    }
    @media screen and (max-width: 1200px) {
        .beakLine{
            left: 22%;
        }
        .beakLine span,u{
            font-size: 14px;
        }
    }
</style>